import { PROJECT_AUDIO_TYPES } from 'consts/audio'
import { IAudioItem } from 'types/audio'
import { generateAndGetAudioDefaultDataForProject } from 'utils/audio'
import { FileRegistry } from 'utils/file-registry/FileRegistry'

const getAudioParameters = async (file: File) => {
  const fileRegistry = FileRegistry.getInstance()
  const url = fileRegistry.registerFile(file)
  return new Promise<{ url: string; duration: number }>((resolve, reject) => {
    const audio = new Audio()

    audio.onloadedmetadata = () => {
      resolve({
        url,
        duration: audio.duration
      })
    }

    audio.onerror = () => {
      fileRegistry.deleteFile(url) // Clean up if error
      reject(new Error(`Failed to load audio file: ${url}`))
    }

    audio.src = url
  })
}

export const prepareAudioData = async (
  files: File[] | FileList,
  nextAvailableLineIndex: number,
  currentTime: number
): Promise<IAudioItem[]> => {
  const audioFiles = await Promise.all(
    Array.from(files).map(async file => {
      const { url, duration } = await getAudioParameters(file)
      return generateAndGetAudioDefaultDataForProject({
        assetId: '',
        duration,
        path: url,
        title: file.name,
        type: PROJECT_AUDIO_TYPES.SOUND,
        projectStart: currentTime,
        lineIndex: nextAvailableLineIndex
      })
    })
  )

  const calculateProjectStart = (index: number) => {
    const previousAudiosDuration = audioFiles
      .slice(0, index)
      .reduce((sum, item) => sum + item.duration, 0)
    return currentTime + previousAudiosDuration
  }

  return audioFiles.map((audio, index) => ({
    ...audio,
    projectStart: calculateProjectStart(index)
  }))
}
